<template>
  <!-- 交易 -->
  <div class="home">
    <!-- 币种切换 -->
    <div class="topBox d-flex justify-between align-center">
      <div>
        <van-icon name="arrow-left" @click="history" />
        <!-- <van-icon name="ascending" size="20px" @click="PopupSho = true" /> -->
      </div>
      <div class="d-flex align-center">
        <div class="topXs d-flex align-center leftTop m-l-xs">
          <img :src="coinsImg" style="width: 30px" />
          <span style="margin-left: 10px; color: #fff" class="fn-18"
            >{{ currentCoin.coin }}/{{ currentCoin.base }}</span
          >
        </div>
      </div>
      <div></div>
    </div>
    <!-- 交易对信息 -->
    <div class="pairBox bor_b">
      <div
        class="priceData"
        :class="marketList.raf * 1 >= 0 ? 'color-buy' : 'color-sell'"
      >
        <div class="bigTit">
          {{ marketList.last.toFixed(4) }}
        </div>
        <div
          :class="
            marketList.raf * 1 >= 0 ? 'color-buy m-t-xs' : 'color-sell m-t-xs'
          "
        >
          {{ (marketList.raf * 100).toFixed(4) }}%
        </div>
      </div>
      <ul>
        <!-- 最高价 -->
        <li class="d-flex justify-between align-center">
          <div>24最高价</div>
          <div class="color-light">
            {{ Number(marketList.high24h).toFixed(4) }}
          </div>
        </li>
        <li class="d-flex justify-between align-center">
          <div>24最低价</div>
          <div class="color-light">
            {{ Number(marketList.low24h).toFixed(4) }}
          </div>
        </li>

        <li class="d-flex justify-between align-center">
          <div>24H量</div>
          <div class="color-light">
            {{ Number(marketList.vol24h).toFixed(4) }} {{ currentCoin.coin }}
          </div>
        </li>
        <li class="d-flex justify-between align-center">
          <div>24H交易额</div>
          <div class="color-light">
            {{ yw(Number(marketList.volCcy24h)) }} {{ currentCoin.base }}
          </div>
        </li>
      </ul>
    </div>
    <!-- k线 -->
    <div class="chart-box">
      <div
        id="kline_container"
        :class="{ hidden: currentImgTable === 's' }"
      ></div>
    </div>
    <!-- 买卖盘 -->
    <!-- <van-tabs>
      <van-tab title="买卖盘" name="0"></van-tab>
    </van-tabs> -->
    <div class="vanMy d-flex">
      <van-tabs swipe-threshold="1" v-model="curOrderTit">
        <van-tab title="委托订单" name="1"> </van-tab>
      </van-tabs>
      <div></div>
    </div>
    <div class="buysellBox" v-if="curOrderTit == 1">
      <ul>
        <li class="d-flex justify-between align-center">
          <div>买</div>
        </li>
        <li
          class="boxs d-flex justify-between align-center"
          v-for="(item, index) in plate.bidRows"
          :key="index + 'a'"
        >
          <div class="color-buy">{{ Number(item.quantity).toFixed(2) }}</div>
          <div>{{ Number(item.price).toFixed(3) }}</div>
          <div
            class="bg"
            :style="{ width: getValue(item.quantity) + '%' }"
          ></div>
        </li>
      </ul>
      <ul>
        <li class="d-flex justify-between align-center">
          <div>卖</div>
        </li>
        <li
          class="boxs d-flex justify-between align-center"
          v-for="(item, index) in plate.askRows"
          :key="index + 'b'"
        >
          <div>{{ Number(item.price).toFixed(3) }}</div>
          <div class="color-sell">{{ Number(item.quantity).toFixed(2) }}</div>
          <div
            class="bg bg2"
            :style="{ width: getValue(item.quantity) + '%' }"
          ></div>
        </li>
      </ul>
    </div>

    <!-- 现货 买入卖出 -->
    <div class="btnBox">
      <!-- 买入    @click="goLink('/m_index/exchange/exchangeTrade', isLogin, curCoin)"-->
      <div class="green fn-center" @click="history">买入</div>
      <!-- 卖出 @click="goLink('/m_index/exchange/exchangeTrade', isLogin, curCoin)"-->
      <div class="red fn-center" @click="history">卖出</div>
    </div>
    <van-popup
      round
      v-model="PopupSho"
      position="left"
      :style="{ height: '100%', width: '80%' }"
    >
      <div class="hotMarket-box">
        <!--  <IndexList @childEvent="getSchoolName" ref="indexList"></IndexList>-->
      </div>
    </van-popup>
    <!-- <Tabbar :active="1"></Tabbar> -->
  </div>
</template>
<script>
import Vue from "vue";
import math from "@/assets/js/math";
import { mapState } from "vuex";
import { Tab, Tabs } from 'vant';
Vue.use(Tab).use(Tabs);
import $ from "@/assets/js/jquery.min.js";
import Datafeeds from "@/assets/js/charting_library/datafeed/bitrade.js";
// import IndexList from "./components/indexList";
var Stomp = require("stompjs");
var SockJS = require("sockjs-client");
var moment = require("moment-timezone");
// var wsPath = "ws://192.168.2.177:9993/api/websocket/All/"; //测试
var wsPath = "wss://tianyis.me/api/websocket/All/"; //正式
import qs from "qs";
export default {
  data() {
    return {
      trade: {
        rows: [],
      },
      curOrderTit: 1,
      marketList: {
        last: 0,
        raf: 0,
        volCcy24h: 0,
        vol24h: 0,
        low24h: 0,
        high24h: 0,
      }, //行情
      PopupSho: false,
      currentCoinIsFavor: false,
      collecRequesting: false,
      curCoin: "",
      // 下拉菜单
      isSelectShow: false,
      // 通过 actions 属性来定义菜单选项
      actions: [],
      //当前市场上的交易币种，按交易对分
      coins: {
        _map: [],
        USDT: [],
        BTC: [],
        ETH: [],
        USDT2: [],
        BTC2: [],
        ETH2: [],
        favor: [],
      },
      dataIndex: [],
      basecion: "usdt",
      defaultPath: "btc_usdt",
      // 当前币种
      currentCoin: {
        base: "",
        coin: "",
        symbol: "",
      },
      currentImgTable: "k",
      // CNYRate: null,
      coinScale: 0,
      baseCoinScale: 4,
      datafeed: null,
      // 最新价的盘口table 数据;
      plate: {
        maxPostion: 10,
        askRows: [],
        bidRows: [],
      },
      baseApi: process.env.VUE_APP_IMG,
      coinsImg: "",
      resolution: "5MIN",
      stompClient: null,
    };
  },
  created() {
    console.log(localStorage.getItem("symbolEchange"),'localStorage.getItem("symbolEchange")');
    this.init(localStorage.getItem("symbolEchange")!=null?localStorage.getItem("symbolEchange"):'BTC/USDT');
  },
  components: {
    // IndexList,
  },
  beforeDestroy() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect();
      this.stompClient = null;
    }
  },
  methods: {
    yw(val) {
      val = parseFloat(val);
      if (!val) {
        return parseFloat(0).toFixed(2);
      }
      if (val < 10000) {
        return val.substring(0);
      } else if (val < 100000000) {
        // (parseFloat(val) / 10000).toFixed(n)
        val = (parseFloat(val) / 1000000).toFixed(2) + "M";
        return val;
      } else {
        // val = (parseFloat(val) / 100000000).toFixed(n) + '亿'
        val = (parseFloat(val) / 1000000000).toFixed(2) + "B";
        return val;
      }
    },

    // 初始化
    init(params) {
      // if (localStorage.getItem("symbolEchange") != null) {
      //   // this.SyboList.syboml = localStorage.getItem("symbolEchange");
      // }
      console.log(localStorage.getItem("symbolEchange"),'asas2');
      if (params == undefined) {
        params = this.defaultPath;
      }
      this.curCoin = params;
      const basecion = params.split("_")[1];
      if (basecion) {
        this.basecion = basecion;
      }
      var coin = params.toUpperCase().split("/")[0];
      var base = params.toUpperCase().split("/")[1];

      this.coinsImg =
        coin == "LQD"
          ? require("../../assets/img/page/LQD.png")
          : "https://qhzx-kline2.oss-ap-southeast-1.aliyuncs.com/logos/" +
            coin +
            ".png";
      this.currentCoin.symbol = coin + "/" + base;
      this.currentCoin.coin = coin;
      this.currentCoin.base = base;

      this.getSymbol(); //包含 K线图、getFavor、startWebsock等
      this.initWebSocket();
    },

    // 获取币种列表 包含 K线图、getFavor、startWebsock等
    getSymbol() {
      this.startWebsock();
    },

    // 连接成功
    onConnected(that, stompClient) {
      let id = that.member ? that.member.userId : Date.now();
      that.initWebSocket();
      that.currentCoin.id = id;
      that.datafeed = new Datafeeds.WebsockFeed(
        "https://tianyis.me/api/exchange/gitHisKill",
        that.currentCoin,
        stompClient,
        that.baseCoinScale
      );

      that.getKline();
      //订阅价格变化消息 行情
      stompClient.subscribe("/topic/cheng/tickers/" + id, function (msg) {
        var resp = JSON.parse(msg.body);

        that.marketList = resp;
        
      });
      //订阅盘口
      stompClient.subscribe("/topic/cheng/plate/" + id, function (msg) {
        var resp = JSON.parse(msg.body);
      
        that.plate.askRows = resp.asks;
        that.plate.bidRows = resp.bids;
       
      });
    },
    initWebSocket() {
      if (typeof WebSocket == "undefined") {
        console.log("您的浏览器不支持WebSocket");
      } else {
        console.log("您的浏览器支持WebSocket");
        let id = 0;
        if (this.member == null) {
          id = Date.now();
        } else {
          id = this.member.userId;
        }
        // console.log("您的浏览器支持WebSocket");
        //实现化WebSocket对象，指定要连接的服务器地址与端口  建立连接
        var wsPathStr = wsPath + id;
        var socket = new WebSocket(wsPathStr);
        this.socketLst = socket;
        let that = this;
        //打开事件
        socket.onopen = function () {
          that.Toime(socket);
          setInterval(() => {
            that.Toime(socket);
          }, 50000);
        };
        //关闭事件
        socket.onclose = function () {
          console.log("Socket已关闭");
          window.location.reload();
          // this.initWebSocket();
        };
        //发生了错误事件
        socket.onerror = function () {
          window.location.reload();
          // this.initWebSocket();
          //此时可以尝试刷新页面
        };
      }
    },
    Toime(socket) {
      let id = 0;
      if (this.member == null) {
        id = Date.now();
      } else {
        id = this.member.userId;
      }

      let arr = JSON.stringify({
        ping: "ping",
        id: id,
        symbol: this.currentCoin.symbol,
        time: this.resolution,
      });
      socket.send(arr);
    },
    // 开启ws
    startWebsock() {
      var that = this;
      var socket = new SockJS("https://tianyis.me/api/market-ws");
      that.stompClient = Stomp.over(socket);
      that.stompClient.debug = false;
   
      that.stompClient.connect(
        {},
        (frame) => {
          that.onConnected(that,that.stompClient);
        },
        that.onError
      );
    },
    onError(error) {
      console.log("连接失败", error);
      this.reconnect();
    },
    getCoin(symbol) {
      return this.coins._map[symbol];
    },
        // 获取深度
        getValue(amount) {
      //获取下面颜色
      const arr = this.plate.bidRows
        .concat(this.plate.askRows)
        .map((item) => item.quantity);
      let max = Math.max(...arr);
      return math.division(amount, max, 2) * 100;
    },
   // 断开重连使用定时器定时连接服务器
   reconnect() {
      setTimeout(() => {
        this.startWebsock();
      }, 2000);
    },

    // 获取K线
    getKline() {
      console.log("that.datafeed", this.datafeed);
      var that = this;
      let config = {
        autosize: true,
        height: 320,
        fullscreen: true,
        symbol: that.symbol,
        interval: "5", // 默认K线周期
        timezone: "Asia/Shanghai",
        toolbar_bg:  "#080402",
        container_id: "kline_container",
        datafeed: that.datafeed,
        library_path: "/static/charting_library/",
        locale: this.$cookies.get("lang"),
        debug: false,
        drawings_access: {
          type: "black",
          tools: [
            {
              name: "Regression Trend",
            },
          ],
        },
        disabled_features: [
          "use_localstorage_for_settings",
          "header_resolutions", // 隐藏周期设置
          "header_symbol_search", // 隐藏品种搜索
          "widget_logo",
          "control_bar",
          "main_series_scale_menu",
          "legend_context_menu",
          "symbol_search_hot_key",
          "symbol_info",
          "edit_buttons_in_legend",
          "pane_context_menu",
          "header_indicators", // 隐藏指标
          "header_chart_type", // 隐藏图表类型
          "header_fullscreen_button", //隐藏头部全屏按钮
          "header_screenshot", //隐藏截屏按钮
          "left_toolbar", //隐藏左边工具栏
          "header_saveload", // 隐藏保存图表、加载图表
          "header_interval_dialog_button", //隐藏设置周期按钮
          "timeframes_toolbar", //隐藏底部刻度栏
          "header_undo_redo", //隐藏撤销重做按钮
          "header_compare", //隐藏比较/增加商品按钮
          "header_settings", // 隐藏设置
          "volume_force_overlay",
          "chart_zoom",
        ],
        // enabled_features: [
        //   "disable_resolution_rebuild",
        //   "keep_left_toolbar_visible_on_small_screens", //防止左侧工具栏在小屏幕上消失
        //   "hide_last_na_study_output",
        //   "move_logo_to_main_pane",
        //   "dont_show_boolean_study_arguments",
        //   "use_localstorage_for_settings",
        //   "remove_library_container_border",
        //   "save_chart_properties_to_local_storage",
        //   "side_toolbar_in_fullscreen_mode",
        //   "constraint_dialogs_movement",
        //   "hide_left_toolbar_by_default",
        //   "left_toolbar",
        //   "same_data_requery",
        //   "header_in_fullscreen_mode",
        // ],
        //成交量样式
        studies_overrides: {
          "volume.volume.color.0": "#fa5252",
          "volume.volume.color.1": "#12b886",
          "volume.volume.transparency": 25,
        },
        custom_css_url: "/static/charting_library/static/bundles/common.css",
        supported_resolutions: ["1", "5", "15", "30", "60", "1D", "1W", "1M"],
        charts_storage_url: "http://saveload.tradingview.com",
        charts_storage_api_version: "1.1",
        client_id: "tradingview.com",
        user_id: "public_user_id",
        overrides: {
          "paneProperties.background": "#080402",
          "paneProperties.vertGridProperties.color": "#080402",
          "paneProperties.horzGridProperties.color": "#080402",
          "scalesProperties.backgroundColor": "#080402",
          "scalesProperties.textColor": "#7b9ca7",
          "paneProperties.legendProperties.showLegend": false, // 隐藏左上角symbol
          volumePaneSize: "small", // 把分离出来的交易量所占的位置缩小
          "paneProperties.topMargin": 0, //上边距，k线距离标题
          "mainSeriesProperties.candleStyle.upColor": "#07C38D",
          "mainSeriesProperties.candleStyle.downColor": "#FF493E",
          "mainSeriesProperties.candleStyle.borderUpColor": "#07C38D",
          "mainSeriesProperties.candleStyle.borderDownColor": "#FF493E",

          "paneProperties.leftAxisProperties.show": false,
          "scalesProperties.lineColor": "rgba(0, 0, 0, 0)",
        },
        time_frames: [
          {
            text: "1min",
            resolution: "1",
            description: "realtime",
            title: "分时",
          },
          {
            text: "1min",
            resolution: "1",
            description: "1min",
          },
          {
            text: "5min",
            resolution: "5",
            description: "5min",
          },
          {
            text: "15min",
            resolution: "15",
            description: "15min",
          },
          {
            text: "30min",
            resolution: "30",
            description: "30min",
          },
          {
            text: "1hour",
            resolution: "60",
            description: "1hour",
            title: "1hour",
          },
   
          {
            text: "1day",
            resolution: "1D",
            description: "1day",
            title: "1day",
          },
          {
            text: "1week",
            resolution: "1W",
            description: "1week",
            title: "1week",
          },
          {
            text: "1mon",
            resolution: "1M",
            description: "1mon",
          },
        ],
      };
      if (that.theme === "light") {
        config.toolbar_bg = "#fff";
        config.custom_css_url =
          "/static/charting_library/static/bundles/common_day.css";
        config.overrides["paneProperties.background"] = "#fff";
        config.overrides["mainSeriesProperties.candleStyle.upColor"] =
          "#a6d3a5";
        config.overrides["mainSeriesProperties.candleStyle.downColor"] =
          "#ffa5a6";
        config.overrides["paneProperties.vertGridProperties.color"] = "#fff";
        config.overrides["paneProperties.horzGridProperties.color"] = "#fff";
      }
      require([
        "@/assets/js/charting_library/charting_library.min.js",
      ], function (tv) {
        var widget = (window.tvWidget = new TradingView.widget(config));
        widget.onChartReady(function () {
          widget.chart().executeActionById("drawingToolbarAction");
          widget
            .chart()
            .createStudy("Moving Average", false, false, [5], null, {
              "plot.color": "#EDEDED",
            });
          widget
            .chart()
            .createStudy("Moving Average", false, false, [10], null, {
              "plot.color": "#ffe000",
            });
          widget
            .chart()
            .createStudy("Moving Average", false, false, [30], null, {
              "plot.color": "#ce00ff",
            });
          widget
            .chart()
            .createStudy("Moving Average", false, false, [60], null, {
              "plot.color": "#00adff",
            });
            widget
            .createButton()
            .attr("title", "M1")
            .on("click", function () {
              if ($(this).hasClass("selected")) return;
              $(this)
                .addClass("selected")
                .parent(".group")
                .siblings(".group")
                .find(".button.selected")
                .removeClass("selected");
              widget.chart().setChartType(1);
              widget.setSymbol("", "1");
              that.resolution = "1MIN";
              that.Toime(that.socketLst);
            })
            .append("<span>M1</span>");
          widget
            .createButton()
            .attr("title", "M5")
            .on("click", function () {
              if ($(this).hasClass("selected")) return;
              $(this)
                .addClass("selected")
                .parent(".group")
                .siblings(".group")
                .find(".button.selected")
                .removeClass("selected");
              widget.chart().setChartType(1);
              widget.setSymbol("", "5");
              that.resolution = "5MIN";
              that.Toime(that.socketLst);
            })
            .append("<span>M5</span>")
            .addClass("selected");
          widget
            .createButton()
            .attr("title", "M15")
            .on("click", function () {
              if ($(this).hasClass("selected")) return;
              $(this)
                .addClass("selected")
                .parent(".group")
                .siblings(".group")
                .find(".button.selected")
                .removeClass("selected");
              widget.chart().setChartType(1);
              widget.setSymbol("", "15");
              that.resolution = "15MIN";
              that.Toime(that.socketLst);
            })
            .append("<span>M15</span>");
          widget
            .createButton()
            .attr("title", "M30")
            .on("click", function () {
              if ($(this).hasClass("selected")) return;
              $(this)
                .addClass("selected")
                .parent(".group")
                .siblings(".group")
                .find(".button.selected")
                .removeClass("selected");
              widget.chart().setChartType(1);
              widget.setSymbol("", "30");
              that.resolution = "30MIN";
              that.Toime(that.socketLst);
            })
            .append("<span>M30</span>");
          widget
            .createButton()
            .attr("title", "H1")
            .on("click", function () {
              if ($(this).hasClass("selected")) return;
              $(this)
                .addClass("selected")
                .parent(".group")
                .siblings(".group")
                .find(".button.selected")
                .removeClass("selected");
              widget.chart().setChartType(1);
              widget.setSymbol("", "60");
              that.resolution = "1HOU";
              that.Toime(that.socketLst);
            })
            .append("<span>H1</span>");
          widget
            .createButton()
            .attr("title", "D1")
            .on("click", function () {
              if ($(this).hasClass("selected")) return;
              $(this)
                .addClass("selected")
                .parent(".group")
                .siblings(".group")
                .find(".button.selected")
                .removeClass("selected");
              widget.chart().setChartType(1);
              widget.setSymbol("", "1D");
              that.resolution = "1DAY";
              that.Toime(that.socketLst);
            })
            .append("<span>D1</span>");
        });
      });
    },
    history() {
      let href = (
        this.currentCoin.coin +
        "_" +
        this.currentCoin.base
      ).toLowerCase();
      this.$router.push({
        path: "/Exchange",
        query: {
          href,
        },
      });
      // console.log(this.currentCoin.coin,this.currentCoin.base);
      // history.back()
    },
    // 选择下拉菜单，切换当前的币种
    onSelect(currentRow) {
      this.init(currentRow.href);
    },
    goLink(path, flag, pair_name) {
      if (flag == false) {
        this.$toast(this.$t("member.e5"));
      } else {
        if (pair_name) {
          this.$router.push({
            path,
            query: {
              pair_name: pair_name,
            },
          });
        } else {
          this.$router.push({
            path,
          });
        }
      }
    },
  },
  computed: {
    ...mapState({
      theme: "theme",
    }),
    isLogin() {
      return this.$store.getters.isLogin;
    },
    wsUrl() {
      return this.$store.state.ws;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    member: function () {
      return this.$store.getters.member;
    },
  },
  watch: {
    $route(to, from) {
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
// 引入全局的样式
@import "@/assets/scss/base.scss";

#kline_container {
  height: 45vh !important;
}

/deep/ iframe {

  height: 100% !important;
}

.home {
  min-height: 100vh !important;
  height: auto !important;

  .vanMy {
    border-top: 0.02rem solid #f89b19 ;
    border-bottom: 0.02rem solid #f89b19 ;
    /deep/ .van-tabs__nav {
      background: transparent !important;
    }

    /deep/ .van-tab__text {
      color: #fff !important;
    }

    /deep/ .van-tab--active {
      // color: $light !important;
      color: #ffc27f !important;
      border-radius: 4px !important;
    }

    /deep/ .van-tabs__line {
      // background-color: #ffc27e;
      width: 60px;
    }

    /deep/ .van-tabs__line::before {
      background: transparent;
    }

    /deep/ .van-tab {
      border-right: none !important;
      font-size: 14px !important;
      font-weight: 600;
    }

    /deep/ .van-tabs__nav--card {
      margin: 0;
    }
  }

  // 热门行情
  .hotMarket-box {
    background: $panel-1;
    padding: 15px;
    border-radius: 20px 20px 0px 0px;
    height: 100%;

    /deep/ .van-tabs__nav {
      background: $panel-1;
    }

    /deep/ .van-tab--active {
      color: $light !important;
      // color: #000 !important;
      background: $panel-1;
      border-radius: 4px !important;
    }

    /deep/ .van-tab {
      border-right: none !important;
      font-size: 12px !important;
      font-weight: 600;
    }

    /deep/ .van-tabs__nav--card {
      margin: 0;
    }

    .titBox {
      display: grid;
      grid-template-columns: 40% 36% 22%;
      justify-content: space-between;
      margin-top: 10px;
    }

    .coinListBox {
      li {
        display: grid;
        grid-template-columns: 40% 36% 22%;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;

        .coinBox {
          display: flex;
          align-items: center;

          img {
            width: 30px;
            height: 30px;
            margin-right: 10px;
          }

          .nums {
            font-size: 12px;
          }
        }

        .price {
          font-size: 18px;
          font-weight: 500;
        }

        .upsDowns {
          width: 100%;
          height: 30px;
          line-height: 30px;
          border-radius: 4px 4px 4px 4px;
        }
      }
    }
  }

  /deep/ .van-action-sheet {
    max-height: 45%;
  }

  /deep/ .van-icon {
    font-size: 20px;
    // color: $text-color !important;
  }

  .topBox {
    padding: 30px 15px 15px 15px;

    .leftTop {
      /deep/ .van-icon {
        font-size: 16px;
        margin-left: 6px;
      }
    }
  }

  .pairBox {
    padding: 15px;
    display: grid;
    grid-template-columns: 34% 66%;
    border-top: 0.02rem solid #f89b19 !important;
    font-size: 12px;
    border-bottom: 0.02rem solid #f89b19 ;
    .priceData {
      border-right: 1px solid var(--border-color);

      .bigTit {
        font-size: 18px;
        margin-bottom: 10px;
      }
    }

    ul {
      margin-left: 15px;

      // display: grid;
      // grid-template-columns: 49% 49%;
      // justify-content: space-between;
      li {
        margin: 3px 0;
        div {
          &:nth-child(2) {
            color: #fff !important;
          }
        }
      }
    }
  }

  .chart-box {
    .imgas {
      position: absolute;
      top: 60%;
      margin-left: 30px;
    }
    // height: 370px;
    width: 100%;
    overflow: hidden;

    #kline_container {
      background: transparent;
      // background: rgba(11, 21, 29, 2);
    }
  }
  .buysellBoxs {
    padding: 15px;
  }
  .buysellBox {
    display: grid;
    grid-template-columns: 49% 49%;
    justify-content: space-between;
    padding: 15px;
    margin-bottom: 50px;
    padding-bottom: 100px;
    .boxs{
      font-size: 12px;
        position: relative;
        margin: 3px 0;
        padding: 2px 2px;
     

        .bg {
          position: absolute;
          right: 0;
          top: 0;
          background: rgba(248, 100, 63, 0.16);
          height: 100%;
          z-index: 0;
        }

        .bg2 {
          background: rgba(8, 200, 99, 0.16);
        }
    }
    li {
      padding: 2px 0;
      margin: 5px 0;
    }
  }

  .btnBox {
    padding: 0 15px;
    margin: 10px 0;
    position: fixed;
    bottom: 0px;
    width: 100%;
    display: grid;
    grid-template-columns: 49% 49%;
    justify-content: space-between;

    div {
      padding: 10px 0;
      border-radius: 3px;
    }
  }
}
</style>
